import { FC } from 'react';
import { Icon } from 'common-components';
import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import classNames from 'classnames';
import styles from './copyToClipboard.module.scss';
import { useTranslationContext } from '../../contexts/translationContext';

const CopyToClipboard: FC<CopyToClipboardProps> = (props: CopyToClipboardProps) => {
    const {
        text,
        isCopied,
        onCopy,
        isVisible = false,
        isAbsolute = true,
        includeTooltip = true,
        title,
        copiedText
    } = props;

    const { translate } = useTranslationContext();

    const COPIED = translate('Copied');
    const COPY_TO_CLIPBOARD = translate('CopyToClipboard');

    const onCopyHandler = async () => {
        await navigator.clipboard.writeText(text);
        onCopy(text);
    };

    const absoluteStyle = {
        position: 'absolute',
        left: '100%',
        top: '50%',
        transform: 'translate(0, -50%)'
    };

    const containerStyle = {
        opacity: isVisible ? 1 : 0,
        ...(isAbsolute ? absoluteStyle : {})
    };

    return (
        <div
            className={classNames(styles.container, !isAbsolute && styles['button-container'])}
            style={containerStyle as React.CSSProperties}
        >
            {includeTooltip ? (
                <Tooltip
                    title={COPY_TO_CLIPBOARD}
                    placement={'top-start'}
                    slotProps={{
                        popper: {
                            sx: {
                                [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                    {
                                        marginBottom: '0.2rem'
                                    }
                            }
                        }
                    }}
                >
                    <span onClick={onCopyHandler}>
                        <Icon name={'copyAdmin'} className={styles['icon-wrapper']} />
                        {title && <span>{title}</span>}
                    </span>
                </Tooltip>
            ) : (
                <span onClick={onCopyHandler}>
                    <Icon name={'copyAdmin'} className={styles['icon-wrapper']} />
                    {title && <span>{title}</span>}
                </span>
            )}
            {isCopied && (
                <div className={styles.tag}>
                    <span>{copiedText || COPIED}</span>
                    <Icon name={'purpleCheck'} className={styles['icon-check-wrapper']} />
                </div>
            )}
        </div>
    );
};

interface CopyToClipboardProps {
    text: string;
    isCopied: boolean;
    onCopy: (value: string) => void;
    isVisible: boolean;
    isAbsolute?: boolean;
    includeTooltip?: boolean;
    title?: string;
    copiedText?: string;
}

export default CopyToClipboard;
